import Layout from "@/views/layout/layout";
import Child from "@/views/layout/child";
const rootPath = "/depo";

const deposit = {
  path: rootPath,
  name: "deposit",
  description: "예금",
  redirect: rootPath + "/deposit/product",
  component: Layout,
  children: [
    {
      path: "product",
      name: "product",
      description: "예금상품",
      redirect: { name: "depositListParent" },
      component: Child,
      children: [
        // 신규 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
        {
          path: "listNV",
          name: "depositListParentNV",
          component: Child,
          redirect: { name: "depositListNV" },
          children: [
            {
              path: "",
              name: "depositListNV",
              description: "예금상품-목록",
              component: () => import("@/views/templates/deposit/savingsProductsListNV"),
              meta: {
                step: 1,
              },
            },
            {
              path: "depositDetailNV",
              name: "depositDetailNV",
              description: "예금상품-상세",
              props: true,
              component: () => import("@/views/templates/deposit/savingsProductsDetailNV"),
              meta: {
                step: 2,
              },
            },
            {
              path: "newReqNV",
              name: "newReqNV",
              redirect: { name: "newReqStep1NV" },
              description: "예금상품-신규",
              component: () => import("@/views/templates/deposit/depositNewReqNV"),
              children: [
                {
                  path: "step1NV",
                  name: "newReqStep1NV",
                  description: "예금상품-만기예상금액조회",
                  component: () => import("@/views/templates/deposit/depositNewReqStep1NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 3,
                  },
                },
                {
                  path: "step2NV",
                  name: "newReqStep2NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep2NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 4,
                  },
                },
                {
                  path: "step3NV",
                  name: "newReqStep3NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep3NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 5,
                  },
                },
                {
                  path: "step4NV",
                  name: "newReqStep4NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep4NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 6,
                  },
                },
                {
                  path: "step5NV",
                  name: "newReqStep5NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep5NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 7,
                  },
                },
                {
                  path: "step6NV",
                  name: "newReqStep6NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep6NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 8,
                  },
                },
                {
                  path: "step7NV",
                  name: "newReqStep7NV",
                  component: () => import("@/views/templates/deposit/depositNewReqStep7NV"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    isLast: true,
                  },
                },
              ],
            },
          ],
        },
        // 신규 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
        {
          path: "list",
          name: "depositListParent",
          component: Child,
          redirect: { name: "depositList" },
          children: [
            {
              path: "",
              name: "depositList",
              description: "예금상품-목록",
              component: () => import("@/views/templates/deposit/savingsProductsList"),
              meta: {
                step: 1,
              },
            },
            {
              path: ":ovsesBrncoPrdctCd:ovsesPpsnCoprDstic",
              name: "depositDetail",
              description: "예금상품-상세",
              props: true,
              component: () => import("@/views/templates/deposit/savingsProductsDetail"),
              meta: {
                step: 2,
              },
            },
            {
              path: "newReq",
              name: "newReq",
              redirect: { name: "newReqStep1" },
              description: "예금상품-신규",
              component: () => import("@/views/templates/deposit/depositNewReq"),
              children: [
                {
                  path: "step1",
                  name: "newReqStep1",
                  description: "예금상품-만기예상금액조회",
                  component: () => import("@/views/templates/deposit/depositNewReqStep1"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 3,
                  },
                },
                {
                  path: "step2",
                  name: "newReqStep2",
                  component: () => import("@/views/templates/deposit/depositNewReqStep2"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 4,
                  },
                },
                {
                  path: "step3",
                  name: "newReqStep3",
                  component: () => import("@/views/templates/deposit/depositNewReqStep3"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 5,
                  },
                },
                {
                  path: "step4",
                  name: "newReqStep4",
                  component: () => import("@/views/templates/deposit/depositNewReqStep4"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 6,
                  },
                },
                {
                  path: "step5",
                  name: "newReqStep5",
                  component: () => import("@/views/templates/deposit/depositNewReqStep5"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 7,
                  },
                },
                {
                  path: "step6",
                  name: "newReqStep6",
                  component: () => import("@/views/templates/deposit/depositNewReqStep6"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 8,
                  },
                },
                {
                  path: "step7",
                  name: "newReqStep7",
                  component: () => import("@/views/templates/deposit/depositNewReqStep7"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    isLast: true,
                  },
                },
              ],
            },
            {
              path: "mobileNewReq",
              name: "mobileNewReq",
              redirect: { name: "mobileDepositNewReqProgress" },
              description: "예금상품-신규",
              component: () => import("@/views/templates/deposit/mobileDepositNewReq"),
              children: [
                {
                  path: "progress",
                  name: "mobileDepositNewReqProgress",
                  description: "베트남 비대면 예금신규(진행)",
                  component: () => import("@/views/templates/deposit/mobileDepositNewReqProgress"),
                  meta: {
                    roles: ["login"],
                  },
                },
                {
                  path: "complete",
                  name: "mobileDepositNewReqComplete",
                  description: "베트남 비대면 예금신규(완료)",
                  component: () => import("@/views/templates/deposit/mobileDepositNewReqComplete"),
                  meta: {
                    transparent: true,
                    roles: ["login"],
                  },
                },
              ],
            },
          ],
        },
        {
          path: "newReqEKYC",
          name: "newReqEKYC",
          redirect: { name: "depositNewReqChkList" },
          description: "예금상품-신규(EKYC)",
          component: () => import("@/views/templates/deposit/depositNewReqEKYC"),
          children: [
            {
              path: "depositNewReqChkList",
              name: "depositNewReqChkList",
              description: "(베트남)예금신규-가입제한사항 체크리스트_모든고객",
              component: () => import("@/views/templates/deposit/depositNewReqChkList"),
            },
            {
              path: "depositNewReqAgreement",
              name: "depositNewReqAgreement",
              description: "(베트남)예금신규-약관동의",
              component: () => import("@/views/templates/deposit/depositNewReqAgreement"),
            },
            {
              path: "depositNewReqSmsAuthentication",
              name: "depositNewReqSmsAuthentication",
              description: "(베트남)예금신규-SMS인증",
              component: () => import("@/views/templates/deposit/depositNewReqSmsAuthentication"),
            },
            {
              path: "depositNewReqCreateEkycEnter",
              name: "depositNewReqCreateEkycEnter",
              description: "(베트남)예금신규-본인확인(생체정보등록)",
              component: () => import("@/views/templates/deposit/depositNewReqCreateEkycEnter"),
            },
            {
              path: "depositNewReqCreateEkycConfirm",
              name: "depositNewReqCreateEkycConfirm",
              description: "(베트남)예금신규-본인확인(생체정보등록정보확인)",
              component: () => import("@/views/templates/deposit/depositNewReqCreateEkycConfirm"),
              meta: {
                transparent: true,
              },
            },
            {
              path: "inputPersonalInfo",
              name: "inputPersonalInfo",
              description: "(베트남)개인정보입력-CIF 업데이트",
              component: () => import("@/views/templates/deposit/inputPersonalInfo"),
            },
          ],
        },
        {
          path: "interestRates",
          name: "interestRatesInfo",
          redirect: { name: "interestRates" },
          description: "금리안내",
          component: Child,
          children: [
            {
              path: "",
              name: "interestRates",
              description: "금리안내",
              component: () => import("@/views/templates/deposit/interestRates2"),
            },
            {
              path: "2",
              name: "interestRates2",
              description: "금리안내",
              component: () => import("@/views/templates/deposit/interestRates"),
            },
          ],
        },
      ],
    },
    {
      path: "termiUpdat",
      description: "예금해지/갱신",
      redirect: { name: "termiUpdatList" },
      component: Child,
      children: [
        {
          path: "list",
          name: "termiUpdatList",
          redirect: { name: "termiUpdat" },
          component: Child,
          children: [
            {
              path: "",
              name: "termiUpdat",
              description: "예금해지/갱신-목록",
              component: () => import("@/views/templates/deposit/termiUpdat"),
              props: () => ({ inAcnKnd: "1", inAcnDtlKnd: "1" }),
              meta: {
                roles: ["login"],
                step: 1,
              },
            },
            {
              path: "termi",
              name: "termiParent",
              redirect: { name: "termiStep1" },
              component: () => import("@/views/templates/deposit/depositTermiParent"),
              description: "예금해지/갱신-해지상세",
              children: [
                {
                  path: "step1",
                  name: "termiStep1",
                  component: () => import("@/views/templates/deposit/depositTermiRenewal0"),
                  meta: {
                    roles: ["login"],
                    step: 2,
                  },
                },
                {
                  path: "step2",
                  name: "termiStep2",
                  component: () => import("@/views/templates/deposit/depositTermiRenewal1"),
                  meta: {
                    roles: ["login"],
                    firstPage: "termiUpdat",
                    step: 3,
                  },
                },
                {
                  path: "step3",
                  name: "termiStep3",
                  component: () => import("@/views/templates/deposit/depositTermiRenewal2"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 4,
                  },
                },
                {
                  path: "approvalComplete",
                  name: "termiApprovalComplete",
                  component: () => import("@/views/templates/admin/approvalComplete"),
                  meta: {
                    roles: ["login", "corp"],
                    transparent: true,
                    isLast: true,
                  },
                },
              ],
            },
            {
              path: "renewal",
              name: "renewalParent",
              redirect: { name: "renewalStep1" },
              component: () => import("@/views/templates/deposit/termiUpdatParent"),
              description: "예금해지/갱신-갱신상세",
              children: [
                {
                  path: "step1",
                  name: "renewalStep1",
                  component: () => import("@/views/templates/deposit/termiUpdatRenewal0"),
                  meta: {
                    roles: ["login"],
                    step: 2,
                  },
                },
                {
                  path: "step2",
                  name: "renewalStep2",
                  component: () => import("@/views/templates/deposit/termiUpdatRenewal1"),
                  meta: {
                    roles: ["login"],
                    firstPage: "termiUpdat",
                    step: 3,
                  },
                },
                {
                  path: "step3",
                  name: "renewalStep3",
                  component: () => import("@/views/templates/deposit/termiUpdatRenewal2"),
                  meta: {
                    roles: ["login"],
                    transparent: true,
                    step: 4,
                  },
                },
                {
                  path: "approvalComplete",
                  name: "renewalApprovalComplete",
                  component: () => import("@/views/templates/admin/approvalComplete"),
                  meta: {
                    roles: ["login", "corp"],
                    transparent: true,
                    step: 5,
                  },
                },
              ],
            },
          ],
        },
        {
          path: "termiUpdatRsultHist",
          name: "termiUpdatRsultHist",
          description: "해지/갱신결과조회",
          component: () => import("@/views/templates/deposit/termiUpdatRsultHist"),
          meta: {
            roles: ["login"],
          },
        },
      ],
    },
  ],
};

export default deposit;
